export const LINE_FAMILY_REQUIRED_MESSAGE = 'Selecione uma família.';
export const EFFORT_REQUIRED_MESSAGE = 'Selecione um esforço.';

export function resolveLineFamilyId(familyId, families, { editing = false } = {}) {
  if (editing || familyId) {
    return familyId || '';
  }
  return families?.[0]?.id || '';
}

export function lineSaveError(familyId) {
  if (!familyId) {
    return LINE_FAMILY_REQUIRED_MESSAGE;
  }
  return '';
}

export function effortConfigSaveError(effortId) {
  if (!effortId) {
    return EFFORT_REQUIRED_MESSAGE;
  }
  return '';
}
